<script setup lang="ts"></script>

<template>
  <div class="filter-bar">
    <slot></slot>
  </div>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";
  .filter-bar :deep() {
    @apply mb-4 flex items-center justify-end gap-4 max-sm:flex-col;

    & > * {
      @apply max-sm:w-full;
    }
  }
</style>
